module.exports = __webpack_public_path__ + "img/Home11.5360c1b5.jpg";